import type { TranslationTag } from '@ps/web-core-intl';
import React from 'react';

import OnboardFlow from '../OnboardFlow/OnboardFlow';
import type { OnboardingInfo } from '../OnboardingContext/OnbordingContext';
import { OnboardingProvider } from '../OnboardingContext/OnbordingContext';

interface Props {
  OnboardStep?: JSX.Element;
  steps: OnboardingInfo<JSX.Element | TranslationTag>[];
  onboardingStoragePath: string;
  arrowClassName?: string;
  coachMarkClassName?: string;
  hideOnboarding: boolean;
}
const OnboardingContainer: React.FC<React.PropsWithChildren<Props>> = ({
  OnboardStep,
  children,
  steps,
  onboardingStoragePath,
  arrowClassName,
  coachMarkClassName,
  hideOnboarding = false
}) => (
  <OnboardingProvider steps={steps} storagePath={onboardingStoragePath}>
    {!hideOnboarding && (
      <OnboardFlow
        onBoardStep={OnboardStep}
        arrowClassName={arrowClassName}
        coachMarkClassName={coachMarkClassName}
      />
    )}
    {children}
  </OnboardingProvider>
);

export default OnboardingContainer;
